import React from 'react';
import { Helmet } from 'react-helmet';
import { Carrier } from 'src/components/Carrier';

const CarrierPage = () => (
  <>
    <Helmet>
      <title> Carrier </title>
    </Helmet>

    <Carrier />
  </>
);

export default CarrierPage;
